import { render, staticRenderFns } from "./OrderStatusSpan.vue?vue&type=template&id=3f921a3a&scoped=true&"
import script from "./OrderStatusSpan.vue?vue&type=script&lang=js&"
export * from "./OrderStatusSpan.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusSpan.vue?vue&type=style&index=0&id=3f921a3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f921a3a",
  null
  
)

export default component.exports